import { useEffect, useState } from 'react';
import { useCaseTabs } from '@lp/core/hooks/useCaseTabs';
import { Case, CaseDuplicateType, CaseStatus } from '@/api/apis/case';
import { useCaseByIdQuery } from '@/queries/case';

export const useCaseDuplicateOpenHandler = () => {
  const [selectedDraftCaseId, setSelectedDraftCaseId] = useState<string>();
  const [pendingCallback, setPendingCallback] = useState<((caseData: Case) => void) | null>(null);
  const [isLoadingCase, setIsLoadingCase] = useState(false);
  const [hideTooltip, setHideTooltip] = useState(false);

  const { openCaseDetails } = useCaseTabs();
  const { data: caseData, isFetching } = useCaseByIdQuery(selectedDraftCaseId);

  const handleDuplicateClick = (duplicate: CaseDuplicateType, onCaseReady: (fullCase: Case) => void) => {
    if (duplicate.status === CaseStatus.Draft) {
      setSelectedDraftCaseId(duplicate.caseId);
      setIsLoadingCase(true);
      setPendingCallback(() => onCaseReady);
    } else {
      openCaseDetails(duplicate.caseId);
    }
  };

  useEffect(() => {
    if (!selectedDraftCaseId || !caseData || isFetching || !pendingCallback) return;

    pendingCallback(caseData as Case);
    setPendingCallback(null);
    setSelectedDraftCaseId(undefined);
    setIsLoadingCase(false);
    setHideTooltip(true);
    setTimeout(() => setHideTooltip(false), 200);
  }, [caseData, isFetching, selectedDraftCaseId, pendingCallback]);

  return {
    isLoadingCase,
    hideTooltip,
    handleDuplicateClick,
  };
};
